module.exports = __webpack_public_path__ + "img/animation.8b6f724c.jpg";